import { ResultDigits } from "./ResultDigits";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, Trophy, Star, Play } from "lucide-react";
import Countdown from "./Countdown";
import { imgUrl } from "../lib/api";

export default function DrawCard({ game, isFav, onToggleFav, onClosed }) {
  const navigate = useNavigate();
  const rt = game.runtime || {};
  const [left, setLeft] = useState(Math.max(0, Math.floor(rt.closing_seconds || 0)));
  useEffect(() => { setLeft(Math.max(0, Math.floor(rt.closing_seconds || 0))); }, [rt.closing_seconds]);
  useEffect(() => {
    if (left <= 0) return undefined;
    const t = setInterval(() => setLeft((l) => (l <= 1 ? 0 : l - 1)), 1000);
    return () => clearInterval(t);
  }, [left > 0]); // eslint-disable-line
  const open = rt.is_open && left > 0;
  const soon = open && left < 600;

  return (
    <div className="rl-card p-4 rl-fade-up no-tap" data-testid={`draw-card-${game.id}`}>
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          {game.logo ? (
            <img src={imgUrl(game.logo)} alt={game.name} className="w-11 h-11 rounded-xl object-cover" />
          ) : (
            <div className="w-11 h-11 rounded-xl rl-gold-bg flex items-center justify-center font-display font-black text-lg">
              {game.name.charAt(0)}
            </div>
          )}
          <div>
            <h3 className="font-display font-bold text-slate-900 text-base leading-tight">{game.name}</h3>
            <span className="text-[10px] uppercase tracking-wider text-slate-500">{game.category}</span>
          </div>
        </div>
        <button
          onClick={() => onToggleFav && onToggleFav(game.id)}
          data-testid={`fav-btn-${game.id}`}
          className="no-tap p-1"
        >
          <Star className={`w-5 h-5 ${isFav ? "fill-blue-600 text-blue-600" : "text-slate-500"}`} />
        </button>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-3 text-center">
        <div className="rounded-lg bg-slate-100 py-1.5">
          <div className="text-[9px] text-slate-500 uppercase">Close</div>
          <div className="text-xs font-semibold text-slate-900">{rt.mode === "interval" ? (rt.close_slot || "—") : game.close_time}</div>
        </div>
        <div className="rounded-lg bg-slate-100 py-1.5">
          <div className="text-[9px] text-slate-500 uppercase">{rt.mode === "interval" ? "Next Draw" : "Draw"}</div>
          <div className="text-xs font-semibold text-slate-900">{rt.mode === "interval" ? (rt.draw_slot || "—") : game.draw_time}</div>
        </div>
        <div className={`rounded-lg py-1.5 ${soon ? "bg-red-50 border border-red-200" : open ? "bg-emerald-50 border border-emerald-200" : "bg-slate-100"}`} data-testid={`draw-close-timer-${game.id}`} data-open={open ? "1" : "0"}>
          <div className={`text-[9px] uppercase flex items-center justify-center gap-0.5 ${soon ? "text-red-600" : open ? "text-emerald-700" : "text-slate-500"}`}><Clock className="w-2.5 h-2.5" />{open ? "Closes in" : "Closes"}</div>
          <div className={`text-sm font-black font-mono ${soon ? "text-red-600 animate-pulse" : open ? "text-emerald-700" : "text-slate-500"}`}><Countdown seconds={rt.closing_seconds} onExpire={onClosed} className={soon ? "text-red-600" : open ? "text-emerald-700" : ""} /></div>
        </div>
      </div>

      <div className="flex items-center justify-between mt-3">
        <div className="flex items-center gap-1.5 text-xs">
          <Trophy className="w-3.5 h-3.5 text-blue-600" />
          <span className="text-slate-500">Last:</span>
          {game.last_result ? (
            <ResultDigits number={game.last_result.winning_number} size="w-6 h-6 text-[11px]" />
          ) : (
            <span className="text-slate-500">--</span>
          )}
        </div>
        <button
          disabled={!open}
          onClick={() => navigate(`/play/${game.id}`)}
          data-testid={`play-btn-${game.id}`}
          className={`flex items-center gap-1.5 font-bold text-sm px-5 py-2 rounded-full no-tap transition-transform active:scale-95 ${
            open ? "rl-gold-bg" : "bg-slate-200 text-slate-500"
          }`}
        >
          <Play className="w-4 h-4" fill="currentColor" />
          {open ? "PLAY" : "CLOSED"}
        </button>
      </div>
    </div>
  );
}
